import {levels} from '../utils';

function getOptions(levels: { [level: number]: string }) {
    const levelNames: { [level: string]: number } = {};

    for (const [id, level] of Object.entries(levels)) {
        levelNames[level.toLowerCase()] = Number(id);
    }

    return {
        customLevels: levels,
        customLevelNames: levelNames
    }
}

export default function createConsoleTransport() {
    const pretty = require('pino-pretty');
    const {Writable} = require('stream');
    const colorize = pretty.colorizerFactory(true);
    const consoleStream = new Writable({
        write(chunk: any, encoding: BufferEncoding, callback: (error?: (Error | null)) => void) {
            try {
                console.log((chunk as Buffer).toString('utf8'));
                callback();
            } catch (error) {
                callback(error as Error);
            }
        }
    });

    return pretty({
        destination: consoleStream,
        singleLine: true,
        ignore: 'hostname,pid',
        customPrettifiers: {
            level(level: string | object): string {
                if (typeof level !== 'string') {
                    level = JSON.stringify(level);
                }
                return colorize(level, getOptions(levels))
            }
        }
    });
}
